import { Action } from '@/authorization/action';
import { Subject } from '@/authorization/subject';
import { useAppAbility } from '@/authorization/use-app-ability';
import { ProductionDeclarationStatusCode } from '@/types/core/purchase-order/production-declaration-status-code';

export function useCanEditProductionDeclaration(
  statusCode: ProductionDeclarationStatusCode,
): boolean {
  const ability = useAppAbility();

  return (
    statusCode === ProductionDeclarationStatusCode.Pending ||
    ability.can(Action.Manage, Subject.ProductionDeclaration)
  );
}
